import React, { useRef, useState } from 'react'
import { addDoc, collection, serverTimestamp, Timestamp } from "firebase/firestore"
import { auth, db } from '../firebase';
import Card from './ui/Card';
import d2 from './RequestWebinarform.module.css'
import MiniLoader from './ui/Visual-utilities/MiniLoader';
import BlueButton from './ui/BlueButton';
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from 'react-icons/md'

function RequestWebinarform(props) {
  const [buttonView, setButtonView] = useState(true);
  const [toggleComponent, setToggleComponent] = useState(false);
  const titleRef = useRef();
  const gradeRef = useRef();
  const subjectRef = useRef();
  const DateTimeRef = useRef();
  

  async function addToDatabase() {
    setButtonView(false);
    const enteredTitle = titleRef.current.value;
    const enteredSubject = subjectRef.current.value;
    const enteredGrade = gradeRef.current.value;
    const enteredDateTime = DateTimeRef.current;
    const d = new Date(enteredDateTime).getTime() / 1000;


    await addDoc(collection(db, "webinars", "webinarsRequests", "requests"), {
      title: enteredTitle,
      subject: enteredSubject,
      grade: enteredGrade,
      desiredTime: new Timestamp(d, 0),
      createdAt: serverTimestamp(),
      requestBy:auth.currentUser.uid,
    });
    // props.onClick();
    setButtonView(true);
  }
  function click(e) {
    e.preventDefault();
    addToDatabase();
    document.getElementById("webinarForm").reset();
  }


  //auto resize text area
  function textareaResize() {
    const tx = document.getElementsByTagName("textarea");
    for (let i = 0; i < tx.length; i++) {
      tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight) + "px;overflow-y:hidden;");
      tx[i].addEventListener("input", OnInput, false);
    }

    function OnInput() {
      this.style.height = "auto";
      this.style.height = (this.scrollHeight) + "px";
    }
  }

  return (
    <>


      <BlueButton onClick={() => setToggleComponent(!toggleComponent)}>Request a Webinar{!toggleComponent ? <MdOutlineKeyboardArrowDown size='25' /> : <MdOutlineKeyboardArrowUp size='25' />}</BlueButton>

      <Card >
        {toggleComponent &&
          <div className={d2.newWebinarContainer}>


            <form onSubmit={click} id='webinarForm' >
              <h3>Request a Webinar:</h3>



              <div className={d2.title}> Grade:
                <select required ref={gradeRef} >
                  <option disabled value='defaultValue'> Select Grade:</option>
                  <option value="Grade 1">Grade 1 - EB1</option>
                  <option value="Grade 2">Grade 2 - EB2</option>
                  <option value="Grade 3">Grade 3 - EB3</option>
                  <option value="Grade 4">Grade 4 - EB4</option>
                  <option value="Grade 5">Grade 5 - EB5</option>
                  <option value="Grade 6">Grade 6 - EB6</option>
                  <option value="Grade 7">Grade 7 - EB7</option>
                  <option value="Grade 8">Grade 8 - EB8</option>
                  <option value="Grade 9">Grade 9 - EB9</option>
                  <option value="Grade 10">Grade 10 - S1</option>
                  <option value="Grade 11 -S2S">Grade 11 Science - S2S</option>
                  <option value="Grade 11 -S2E">Grade 11 Economics - S2E</option>
                  <option value="Grade 12 -SG">Grade 12 General Science - SG</option>
                  <option value="Grade 12 -SV">Grade 12 Life Science - SV</option>
                  <option value="Grade 12 -SE">Grade 12 Economy/Sociology - SE</option>
                  <option value="Grade 12 -LH">Grade 12 Humanity/Litterature - LH</option>
                </select>
              </div>


              <div className={d2.title}>  Subject:
                <select required ref={subjectRef} >
                  <option disabled value='defaultValue'> select subject</option>
                  <option value="Math">Math</option>
                  <option value="Physics">Physics</option>
                  <option value="Arabic">Arabic</option>
                  <option value="French">French</option>
                  <option value="English">English</option>
                  <option value="Philosophy">Philosophy</option>
                  <option value="Civic">Civic</option>
                  <option value="History">History</option>
                  <option value="Geography">Geography</option>
                  <option value="Biology">Biology</option>
                  <option value="Chemistry">Chemistry</option>
                  <option value="Informatics">Informatics</option>
                  <option value="Economics">Economics</option>
                  <option value="Sociology">Sociology</option>
                  <option value="Music">Music</option>
                </select>
              </div>

              <div className={d2.title}>Chapters:
                <textarea onChange={() => textareaResize()} type='text' required minLength='1' ref={titleRef} placeholder='What chapters would you like this webinars to be about?' />
              </div>

              <div>   <div className={d2.title}>Date:
                <input type="datetime-local" required ref={DateTimeRef} placeholder='date time' />
              </div></div>
              {buttonView ? <BlueButton type='submit' >Continue</BlueButton> : <button>Creating <MiniLoader /></button>}
            </form>
          </div>}
      </Card>

    </>
  )
}

export default RequestWebinarform